// string manipulation
export const capitalize = (word) => {
  return word.charAt(0).toUpperCase() + word.slice(1)
}

export const formatSnakeCase = (word) => {
  let formattedText = ''
  word = word.split('_')

  word.forEach((v) => {
    formattedText = formattedText + capitalize(v) + ' '
  })
  return formattedText.trim()
}

export const camelToTitle = (camelCase) => camelCase
  .replace(/([A-Z])/g, (match) => ` ${match}`)
  .replace(/^./, (match) => match.toUpperCase())
  .trim()

const firstUppercase = word => word && word.charAt(0).toUpperCase() + word.slice(1)

export const snakeToTitle = (snakecase) => snakecase.split('_').map(word => firstUppercase(word)).join(' ')

export const extractYoutubeID = (url = '') => {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  const match = String(url).match(regExp)
  return (match && match[7].length === 11) ? match[7] : ''
}

// FORMAT BYTES
export const formatBytes = (bytes, decimals = 2) => {
  if (!+bytes) return '0 Bytes'
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

const fakeAxiosPost = async(url, formData, config) => {
  const simulatedTotal = 100 // Total size of the file for progress simulation
  const simulatedDelay = 100 // Simulated delay between progress updates
  const progressIncrement = 10 // Amount to increment progress by

  return new Promise((resolve) => {
    let loaded = 0
    const simulateProgress = () => {
      if (loaded <= simulatedTotal) {
        const event = { loaded, total: simulatedTotal, lengthComputable: true }
        config.onUploadProgress(event)
        loaded += progressIncrement
        setTimeout(simulateProgress, simulatedDelay)
      } else {
        // Simulate a successful response after reaching 100% progress
        const response = { data: 'mockedUUID' }
        resolve(response)
      }
    }

    setTimeout(simulateProgress, simulatedDelay)
  })
}

// UPLOAD_FILE
export const startUploadFile = async({ file, setProgress, setFileUUID, setErrorMessage }) => {
  console.debug('file: helpers.js:52 ༻༺ startUploadFile ༻༺ setErrorMessage:', setErrorMessage)
  console.debug('file: helpers.js:52 ༻༺ startUploadFile ༻༺ setFileUUID:', setFileUUID)
  console.debug('file: helpers.js:52 ༻༺ startUploadFile ༻༺ setProgress:', setProgress)
  console.log(file)
  setProgress(0)

  const demoURL = 'https://api.cloudinary.com/v1_1/demo/image/upload'
  const key = 'docs_upload_example_us_preset'

  const formData = new FormData()
  formData.append('file', file)
  formData.append('upload_preset', key)

  try {
    const response = await fakeAxiosPost(demoURL, formData, {
      onUploadProgress: (event) => {
        if (event.lengthComputable) {
          const percentage = (event.loaded / event.total) * 100
          console.log({ percentage, loaded: event.loaded, eventTotal: event.total })
          setProgress(Math.round(percentage))
        }
      }
    })
    setFileUUID(response.data) // ! Update this to be a UUID
    console.log('File Uploaded (Mock Success)') // ! Update this to be a real UUID.
  } catch (error) {
    setErrorMessage(error.message)
  }
}

export const startFailUploadFile = async({ file, setProgress, setFileUUID, setErrorMessage }) => {
  console.log(file)
  setProgress(0)

  const demoURL = 'https://api.cloudinary.com/v1_1/demo/image/upload'
  const key = 'docs_upload_example_us_preset'

  const formData = new FormData()
  formData.append('file', file)
  formData.append('upload_preset', key)

  try {
    const response = await fakeAxiosPost(demoURL, formData, {
      onUploadProgress: (event) => {
        if (event.lengthComputable) {
          const percentage = (event.loaded / event.total) * 100
          console.log({ percentage, loaded: event.loaded, eventTotal: event.total })
          setProgress(Math.round(percentage))
        }
      }
    })
    setFileUUID(response.data)
    setErrorMessage('Aw damn')
  } catch (error) {
    setErrorMessage(error.message)
  }
}

export const renderIcon = (fileType) => {
  if (fileType === 'application/pdf') return 'fa-file-pdf'
  if (fileType === 'image/jpeg' || fileType === 'image/png' || fileType === 'image/jpg' || fileType === 'image/gif') return 'fa-file-image'
  if (fileType === 'text/csv') return 'fa-file-csv'
  if (fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || fileType === 'application/vnd.ms-excel') return 'fa-file-excel'
  if (fileType === 'application/zip') return 'fa-file-zipper'
  if (fileType === 'application/msword' || fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') return 'fa-file-word'
  if (fileType === 'video/mp4' || fileType === 'video/webm' || fileType === 'video/ogg' || fileType === 'video/3gpp' || fileType === 'video/3gpp2' || fileType === 'video/x-msvideo' || fileType === 'video/quicktime' || fileType === 'video/mp4') return 'fa-file-video'
  return 'fa-file-lines'
}
